﻿/**
 * portal-link.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('portal-link.controller', portalLinkController);

	/** setup injection */
	portalLinkController.$inject = ['$scope', '$sce', 'appSettings', 'portal-favorites.manager'];

	/** implementation */
	function portalLinkController($scope, $sce, appSettings, portalFavoritesManager) {
		/** pubic properties */
		var vm = this;

		/** public methods */
		vm.toggleFavorite = portalFavoritesManager.toggleFavorite;
		vm.getUrl = getUrl;
		vm.getSVG = getSVG;

		/** run init */
		init();

		/** public method implementations */

		/** get the url */
		function getUrl() {
			/** check for preview */
			if (vm.preview) return '';
			return vm.link.linkUrl;
		}

		/** get the svg value */
		function getSVG() {
			return vm.link.iconSVG ? $sce.trustAsHtml(vm.link.iconSVG) : '';
		}

		/** private methods */

		/** initialize */
		function init() {
			/** set callback for favorite */
			portalFavoritesManager.addCallback('portal-favorites', toggleFavorite, false, $scope);
		}


		/** toggle the favorite star */
		function toggleFavorite(favorites) {
			/** find a match in favorites */
			var match = favorites.filter(function(fav){ return fav.portalLinkID === vm.link.portalLinkID; });
			if (match.length > 0) vm.link.isFavorite = true;
			else vm.link.isFavorite = false;
		}
	}
})();